'use strict';

var axios = require('axios');
var consts = require('../consts.js');
var NetworkError = require('../errors/network/NetworkError.js');
var BadRequestError = require('../errors/network/BadRequestError.js');
var LockedError = require('../errors/network/LockedError.js');
var TooManyRequestsError = require('../errors/network/TooManyRequestsError.js');
var helpers = require('./helpers.js');

class AuthApiClient {
    _params;
    _instance;
    constructor(params) {
        this._params = params || {};
        this._instance = axios.create({
            timeout: 5000,
            responseType: 'json',
            withCredentials: true,
            headers: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        });
        this._instance.interceptors.response.use((_) => _, (error) => {
            if (axios.isAxiosError(error)) {
                if (!error.response) {
                    return Promise.reject(this._createError(error?.status || 500, { message: error.message }));
                }
                const { status, data } = error.response;
                const { message, error: errorFromServer } = data;
                const retryAfter = error.response.headers?.[consts.HEADERS.RETRY_AFTER] ||
                    error.response.headers?.[consts.HEADERS.RETRY_AFTER.toLowerCase()];
                if (status === 400 && errorFromServer) {
                    return Promise.reject(new BadRequestError.BadRequestError({
                        code: errorFromServer.code,
                        target: errorFromServer.target,
                        message: errorFromServer.message,
                        details: errorFromServer.details,
                    }));
                }
                return Promise.reject(this._createError(status, { message: message || errorFromServer?.message, meta: { retryAfter } }));
            }
            return Promise.reject(error);
        });
    }
    _createError(status, params) {
        const { message, meta } = params || {};
        const { retryAfter } = meta || {};
        switch (status) {
            case 400:
                return new BadRequestError.BadRequestError({ message });
            case 423:
                return new LockedError.LockedError(message);
            case 429:
                return new TooManyRequestsError.TooManyRequestsError(message, retryAfter);
            default:
                return new NetworkError.NetworkError(message);
        }
    }
    async sendOTPByPhoneNumber(params) {
        const { phone, returnUrl, name, authCodeChannel, source, customer, productName, productId } = params;
        const { prefix, webPath } = this._params;
        const url = helpers.getSilentSignInUrl({ prefix, webPath });
        await this._instance.post(url, {
            phone,
            returnUrl,
            name,
            authCodeChannel,
            source,
            customer,
            productName,
            productId,
        });
    }
    async verifyPhoneNumberByOTP(params) {
        const { phone, code, productId } = params;
        const { prefix, webPath } = this._params;
        const url = helpers.getSilentSignInVerifyUrl({ prefix, webPath });
        const { data } = await this._instance.post(url, { phone, code, productId });
        const { otac, username } = data;
        return { otac, username };
    }
    async getConnectTokenSet(params) {
        const { otac, username } = params;
        const url = helpers.getSilentConnectTokenUrl();
        const { data } = await this._instance.post(url, { otac, username });
        return data;
    }
}

exports.AuthApiClient = AuthApiClient;
//# sourceMappingURL=authApiClient.js.map
